<section class="cta-section">
  <div class="cta-container">
    <div class="">
      <div class="cta-card">
        <div class="cta-glow-top"></div>
        <div class="cta-glow-bottom"></div>
        <span class="cta-shape shape-1"></span><span class="cta-shape shape-2"></span><span
          class="cta-shape shape-3"></span><span class="cta-shape shape-4"></span><span
          class="cta-shape shape-5"></span><span class="cta-shape shape-6"></span>
        <div class="cta-content">
          <span class="cta-badge"><svg aria-hidden="true" class="lucide lucide-rocket w-3.5 h-3.5" fill="none"
              stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z">
              </path>
              <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z">
              </path>
              <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
              <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
            </svg>
            Start today, it's free</span>
          <h2 class="cta-title">
            Ready to build your <br class="hidden sm:block" />dream career?
          </h2>
          <p class="cta-desc">
            Join thousands of candidates preparing smarter and getting hired
            faster with BeExpert.ai.
          </p>
          <div class="cta-actions">
            <button class="btn-primary group" routerLink="/login" data-testid="final-primary-cta">
              Get Started Free<svg aria-hidden="true"
                class="lucide lucide-arrow-right w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg></button><button class="btn-secondary" data-testid="final-secondary-cta" routerLink="/login">
              Explore Jobs
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>